"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _profile = require("@widget/profile");

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Navigate() {
  try {
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var isLogist = profile['user'] && profile['user']['role'] && profile['user']['role'] === 'merchant-logist';
    var isShowPayout = profile['merchant']['type'] === 'INDIVIDUAL' || ['LEGAL', 'ST'].indexOf(profile['merchant']['type']) !== -1 && (profile['merchant']['subaggregator'] || profile['merchant']['c2cMarketplace']) && profile['merchant']['status']['type'] === 'Moderated';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2,
      "data-locator": "invoices.header"
    }, "\u041F\u043B\u0430\u0442\u0435\u0436\u0438")), isShowPayout && !isLogist && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: _defaultModule["default"]['link'],
      to: process.env['PUBLIC_URL'] + '/operations/payouts',
      "data-locator": "invoices.header.link"
    }, "\u0412\u044B\u043F\u043B\u0430\u0442\u044B"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Navigate;
exports["default"] = _default;